import { useEffect, useState } from 'react'

import { spaces } from '@/config/global-parameters'

const useWindowDimensions = () => {
  const [windowSize, setWindowSize] = useState([0, 0])

  useEffect(() => {
    if (windowSize.toString() === [0, 0].toString()) {
      setWindowSize([window.innerWidth, window.innerHeight])
    }
    const handleWindowResize = () => {
      setWindowSize([window.innerWidth, window.innerHeight])
    }

    window.addEventListener('resize', handleWindowResize)

    return () => {
      window.removeEventListener('resize', handleWindowResize)
    }
  }, [windowSize])

  const width = windowSize[0]
  const height = windowSize[1]
  const isBigScreen = width > Number(spaces.maxWidth.replace('px', ''))
  const isMobile = width <= Number(spaces.tabletBreakpoint.replace('px', ''))
  const isDesktoop = width <= Number(spaces.tabletBreakpoint.replace('px', ''))

  return { height, isBigScreen, isDesktoop, isMobile, width }
}

export default useWindowDimensions
